module.exports = {
	"genre": {
		"genreId-1": "Divers",
		"genreId-2": "Blues/Country/Folk",
		"genreId-3": "Blues",
		"genreId-4": "Country",
		"genreId-5": "Folk",
		"genreId-6": "Chanson française",
		"genreId-7": "Interprètes de chanson française",
		"genreId-8": "Chanson française rétro",
		"genreId-9": "Rock français",
		"genreId-10": "Classique",
		"genreId-11": "Électronique ou concrète",
		"genreId-12": "Musique concrète",
		"genreId-13": "Musique électronique",
		"genreId-14": "Musique minimaliste",
		"genreId-15": "Mélodies & Lieder",
		"genreId-16": "Lieder (Allemagne)",
		"genreId-17": "Lieder",
		"genreId-18": "Mélodies",
		"genreId-19": "Mélodies (Angleterre)",
		"genreId-20": "Mélodies (Europe du Nord)",
		"genreId-21": "Mélodies (France)",
		"genreId-22": "Musique concertante",
		"genreId-23": "Autres instruments",
		"genreId-24": "Concertos pour clavier",
		"genreId-25": "Concertos pour violon",
		"genreId-26": "Concertos pour violoncelle",
		"genreId-27": "Musique de chambre",
		"genreId-28": "Autres formations",
		"genreId-29": "Autres instruments en solo",
		"genreId-30": "Piano solo",
		"genreId-31": "Quatuors",
		"genreId-32": "Quintettes",
		"genreId-33": "Duos",
		"genreId-34": "Trios",
		"genreId-35": "Violon solo",
		"genreId-36": "Violoncelle solo",
		"genreId-37": "Musique symphonique",
		"genreId-38": "Ballets",
		"genreId-39": "Musique de scène",
		"genreId-40": "Musiques pour le cinéma",
		"genreId-41": "Ouvertures",
		"genreId-42": "Poèmes symphoniques",
		"genreId-43": "Symphonies",
		"genreId-44": "Musique vocale (profane et sacrée)",
		"genreId-45": "Cantates (profanes)",
		"genreId-46": "Musique chorale (pour chœur)",
		"genreId-47": "Musique pour ensembles vocaux",
		"genreId-48": "Oratorios profanes",
		"genreId-49": "Récitals vocaux",
		"genreId-50": "Musique vocale sacrée",
		"genreId-51": "Cantates sacrées",
		"genreId-52": "Chœurs sacrés",
		"genreId-53": "Messes, Passions, Requiems",
		"genreId-54": "Oratorios sacrés",
		"genreId-55": "Opéra",
		"genreId-56": "Extraits d'opéra",
		"genreId-57": "Intégrales d'opéra",
		"genreId-58": "Opérette",
		"genreId-59": "Diction",
		"genreId-60": "Pédagogie",
		"genreId-61": "Documents historiques",
		"genreId-62": "Humour",
		"genreId-63": "Littérature",
		"genreId-64": "Electro",
		"genreId-65": "Ambient",
		"genreId-66": "Downtempo",
		"genreId-67": "Drum & Bass",
		"genreId-68": "House",
		"genreId-69": "Lounge",
		"genreId-70": "Techno",
		"genreId-71": "Trance",
		"genreId-72": "Trip Hop",
		"genreId-73": "Enfants Ambiance",
		"genreId-74": "Accordéon",
		"genreId-75": "Contes et comptines",
		"genreId-76": "Educatif",
		"genreId-77": "Karaoké",
		"genreId-78": "Musique militaire",
		"genreId-79": "Relaxation",
		"genreId-80": "Jazz",
		"genreId-81": "Be Bop",
		"genreId-82": "Cool jazz",
		"genreId-83": "Free jazz & Avant-garde",
		"genreId-84": "Gospel",
		"genreId-85": "Jazz contemporain",
		"genreId-86": "Jazz fusion & Jazz rock",
		"genreId-87": "Jazz manouche",
		"genreId-88": "Jazz traditionnel & New Orleans",
		"genreId-89": "Jazz vocal",
		"genreId-90": "Latin jazz",
		"genreId-91": "Film",
		"genreId-92": "Bandes originales de films",
		"genreId-93": "Comédies musicales",
		"genreId-94": "Musiques du monde",
		"genreId-95": "Afrique",
		"genreId-96": "Afrobeat",
		"genreId-97": "Asie",
		"genreId-98": "Bossa Nova & Brésil",
		"genreId-99": "Celtique",
		"genreId-100": "Europe de l'Est",
		"genreId-101": "Fado",
		"genreId-102": "Flamenco",
		"genreId-103": "Musique ethnique",
		"genreId-104": "Musique indienne",
		"genreId-105": "Orient",
		"genreId-106": "Raï",
		"genreId-107": "Salsa",
		"genreId-108": "Tango",
		"genreId-109": "World Music",
		"genreId-110": "Yiddish & Klezmer",
		"genreId-111": "Zouk & Antilles",
		"genreId-112": "Pop/Rock",
		"genreId-113": "Alternatif et Indé",
		"genreId-114": "Crooners",
		"genreId-115": "Hard Rock",
		"genreId-116": "Metal",
		"genreId-117": "Pop",
		"genreId-118": "Punk - New Wave",
		"genreId-119": "Rock",
		"genreId-120": "Rock progressif",
		"genreId-121": "Rockabilly",
		"genreId-122": "Variété internationale",
		"genreId-123": "Reggae",
		"genreId-124": "Dancehall",
		"genreId-125": "Dub",
		"genreId-126": "Ska & Rocksteady",
		"genreId-127": "Soul/Funk/R&B",
		"genreId-128": "Acid jazz",
		"genreId-129": "Dance",
		"genreId-130": "Disco",
		"genreId-131": "Funk",
		"genreId-132": "R&B",
		"genreId-133": "Rap",
		"genreId-134": "Soul",
		"genreId-135": "Opérette",
		"genreId-137": "Concertos pour trompette",
		"genreId-138": "Concertos pour instruments à vent",
		"genreId-139": "Crossover",
		"genreId-140": "Documents",
		"genreId-141": "New Age",
		"genreId-142": "Ambiance",
		"genreId-144": "Crossover",
		"genreId-145": "Dixieland",
		"genreId-146": "Ragtime",
		"genreId-147": "Séries TV",
		"genreId-148": "Jeux vidéo",
		"genreId-149": "Amérique latine",
		"genreId-150": "Amérique du Nord",
		"genreId-151": "Europe",
		"genreId-152": "Gipsy",
		"genreId-153": "Musique traditionnelle",
		"genreId-154": "Maghreb",
		"genreId-155": "Russie",
		"genreId-156": "Turquie",
		"genreId-157": "Pop indé",
		"genreId-158": "Chansons paillardes",
		"genreId-159": "Musiques de Noël",
		"genreId-160": "Allemagne",
		"genreId-161": "Ecosse",
		"genreId-162": "Espagne",
		"genreId-163": "Grèce",
		"genreId-164": "Irlande",
		"genreId-165": "Italie",
		"genreId-166": "Portugal",
		"genreId-167": "Enfants",
		"genreId-176": "Musique vocale profane",
		"genreId-173": "Schlager",
		"genreId-171": "Stimmungsmusik",
		"genreId-172": "Volksmusik",
		"genreId-174": "Irish celtic",
		"genreId-175": "Irish popmusic",
		"genreId-168": "Musique folkloriquen Suisse",
		"genreId-178": "Allemand",
		"genreId-177": "Anglais",
		"genreId-170": "Français",
		"genreId-179": "Néerlandais"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiPl.json
// module id = 553
// module chunks = 0